interface Props {
    colors?: string
}

export function ListIcon(props: Props) {
    return (
        <svg width="20" height="14" viewBox="0 0 20 14" fill="none">
            <path d="M6 1H19M6 7H19M6 13H19M1 1H1.01M1 7H1.01M1 13H1.01" stroke={props.colors ? props.colors : "#8383AD"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}
